import { defineComponent as d, ref as s, onMounted as v, onBeforeUnmount as m, watch as b, provide as a, openBlock as h, createElementBlock as _, createElementVNode as w, renderSlot as B } from "vue";
const M = { class: "ist-app" }, y = /* @__PURE__ */ d({
  __name: "IstMainApp",
  props: {
    mobile: { type: Boolean, default: void 0 },
    showMenu: { type: Boolean, default: !0 }
  },
  setup(u) {
    const o = u, n = s(o.mobile), r = s(o.showMenu), i = s(null);
    let t = null;
    v(() => {
      p();
    }), m(() => {
      t && t.disconnect();
    });
    function p() {
      const e = new ResizeObserver(function(l) {
        l.forEach(function(f) {
          const c = f.contentRect;
          console.log(c, o.mobile), o.mobile == null && (n.value = c.width < 600, r.value = !n.value);
        });
      });
      e.observe(i.value), t = e;
    }
    return b(
      () => o.mobile,
      (e) => {
        n.value = e;
      }
    ), a("mobile", n), a("showMenu", r), (e, l) => (h(), _("div", {
      id: "istapp",
      ref_key: "appref",
      ref: i
    }, [
      w("div", M, [
        B(e.$slots, "default", {}, void 0, !0)
      ])
    ], 512));
  }
});
export {
  y as default
};
